// import initFilters from './sections/filters';
import { scrollToEls } from './global/scrollTo';
import headerInit from './sections/header/headerInit';
// import slickify from './dom/slickify';
import cookieWarning from './dom/cookieWarning';
import { clickToggle } from './global/clickToggle';
import dismissablesInit from './components/dismissables';
// import initLoadMore from './sections/products/loadMore';
import initialiseZoom from './components/productZoom';
import { initSort } from './sections/products/sort';
import addToCartBtnInit from './sections/cart/addToCart';
import lazyloadify from './global/lazyload';
import initLoadMore from './sections/products/loadMore';
import { ready, onShopifySectionLoad } from './global/instantiate';
import initAccordion from './components/accordion';
import { getSwatches, popuplateSwatches } from './global/swatches';
import {
  checkIfUserCanBeTracked,
  onConsentLoad,
  setTrackingConsent,
} from './dom/tracking';
import allowGTMTracking from './dom/allowGTMTracking';
import initLabelButtons from './global/labelButtons';
import animations from './dom/animations';
import formLabels from './dom/formLabels';
import actionCountry from './global/actionCountry';
import getCountry from './global/getCountry';
import nostoATC from './global/nostoATC';
import glidify, { glidifyMob } from './dom/glidify';
import initProductAccordions from './dom/accordion';
import subNavActive from './dom/subNavActive';
import focusSearch from './dom/focusSearch';
import { initScrollToProductInListing } from './global/initScrollToProductInListing';
import initAppHeight from './global/appHeight';

/* VS */
import './global/readMore';
import './components/compareButton';
import './global/compare-products.js';

import stockistFilters from './global/stockists-filters';

customElements.define('stockist-filters', stockistFilters);

// Helper functions
window.blubolt = {
  turboLinksActive: false,
  glides: [],
  stickers: {},
  dom: {
    nostoATC,
    glidify,
    glidifyMob,
    initialiseZoom,
    // initFilters,
  },
  consent: {
    checkIfUserCanBeTracked,
    setTrackingConsent,
  },
};

ready(() => {
  initAppHeight();
  initLabelButtons();
  lazyloadify();
  headerInit();
  initProductAccordions();
  nostoATC();
  animations();
  formLabels();
  clickToggle();
  dismissablesInit();
  cookieWarning();
  initSort();
  scrollToEls();
  focusSearch();
  addToCartBtnInit();
  initAccordion();
  glidify();
  glidifyMob();
  initLoadMore(() => {
    lazyloadify();
    popuplateSwatches(window.blubolt.swatches);
    window.ReloadSmartWishlist();
    console.info('Infinite scroll products loaded');
  });
  subNavActive();

  window.blubolt.swatches = getSwatches();
  popuplateSwatches(window.blubolt.swatches);

  getCountry(() =>
  //country
  {
    //anything reuqires geolocation can go here
    actionCountry();
  }
  );

  onConsentLoad((consent) => {
    if (consent) {
      //any tracking can be set up here
      //this fires on page load if a user has already consented or at the moment of consent
      console.info('user allows tracking!');
      allowGTMTracking();
    }
  });

  initScrollToProductInListing();
});

onShopifySectionLoad(() => {
  headerInit();
  clickToggle();
  lazyloadify();
  glidify();
});

// Mini cart open/close logic.
document.addEventListener('DOMContentLoaded', function() {
  const cartIcon = document.querySelector('.js-minicart-trigger');
  
  if (cartIcon) {
    cartIcon.addEventListener('click', function(e) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.items && cart.items.length === 0) {
            window.location.href = '/cart';
          } else {
            document.body.classList.add('minicart-open');
          }
        })
        .catch(err => {
          console.error('Error fetching cart:', err);
          // fallback: open minicart
          document.body.classList.add('minicart-open');
        });
    });
  } else {
    console.warn('Cart icon (.js-minicart-trigger) not found');
  }

  // Close minicart when clicking close button or outside minicart
  const miniCart = document.querySelector('.minicart');
  const closeBtn = document.querySelector('.minicart-close-button');

  if (!miniCart) {
    console.warn('Mini cart (.minicart) not found');
  }
  if (!closeBtn) {
    console.warn('Minicart close button (.minicart-close-button) not found');
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      document.body.classList.remove('minicart-open');
    });
  }

  document.addEventListener('click', function(event) {
    if (document.body.classList.contains('minicart-open')) {
      // If minicart exists, check if click is outside minicart and cart icon
      if (miniCart) {
        if (!miniCart.contains(event.target) && !cartIcon.contains(event.target)) {
          console.log('Clicked outside minicart and cart icon, closing minicart');
          document.body.classList.remove('minicart-open');
          console.log('minicart-open class removed:', document.body.classList.contains('minicart-open'));
        }
      } else {
        // If minicart does not exist, close on any click outside cart icon
        if (!cartIcon.contains(event.target)) {
          console.log('Minicart missing, clicked outside cart icon, closing minicart');
          document.body.classList.remove('minicart-open');
          console.log('minicart-open class removed:', document.body.classList.contains('minicart-open'));
        }
      }
    }
  });
});
